import { AlertRuleV9RequestCheckMode } from '@/api-client/metav8Over/model';

export const DEFAULT_VALUE = {
  metric: {
    maximumOccurrences: -1,
    checkRepeat: 1,
  },
  event: {
    checkRepeat: 1,
  },
};

export const CHECK_INTERVAL_OPTION = {
  s: {
    default: 5,
    min: 5,
    max: 2678400,
    step: 5,
  },
  m: {
    default: 1,
    min: 1,
    max: 44640,
    step: 1,
  },
  h: {
    default: 1,
    min: 1,
    max: 744,
    step: 1,
  },
  d: {
    default: 1,
    min: 1,
    max: 365,
    step: 1,
  },
};

export const ALERT_CONTROL_NONE = '-1';
export const ALERT_CONTROL_TYPE = {
  ALERT_STOP: 0,
  ALERT_CLEAR: 1,
} as const;

// 체크 모드: LEVEL_CHANGE_ONLY 는 최대 발생 건수·알람 제어 시간을 사용하지 않고 레벨 전이 시점에만 알람을 발생시킨다.
export const CHECK_MODE = AlertRuleV9RequestCheckMode;

export type CheckModeValue = AlertRuleV9RequestCheckMode;
